import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { WixConnect, WixProvide } from 'widget/player-widget/utils/wix-connect';

import Icon from 'widget/player-widget/components/icon/icon';

import styles from './dropdown.styl';


@WixConnect(styles)
class Option extends React.Component {

  static propTypes = {
    selected: React.PropTypes.bool,
    value: React.PropTypes.string,
    children: React.PropTypes.any,
    onClick: React.PropTypes.func,
    className: React.PropTypes.string,
  };

  static defaultProps = {
    selected: false,
  };

  @autobind
  handleClick() {
    const { value, onClick } = this.props;
    onClick(value);
  }

  render() {
    const { children, selected, className } = this.props;

    const styleNames = classnames('option', {
      selected,
    });

    return (
      <div styleName={styleNames}
           className={className}
           onClick={this.handleClick}>
        {children}
      </div>
    );
  }
}


@WixProvide
@WixConnect(styles)
export default class Dropdown extends React.Component {

  static propTypes = {
    value: React.PropTypes.string,
    options: React.PropTypes.arrayOf(React.PropTypes.shape({
      value: React.PropTypes.string,
      label: React.PropTypes.string,
    })),
    onChange: React.PropTypes.func,
    rounded: React.PropTypes.bool,
    className: React.PropTypes.string,
    labelClassName: React.PropTypes.string,
    optionClassName: React.PropTypes.string,
    selectedOptionClassName: React.PropTypes.string,
  };

  static defaultProps = {
    onChange: _.noop,
    rounded: false,
  };

  state = {
    open: false,
  };

  componentWillMount() {
    const { options } = this.props;
    let { value } = this.props;

    if (_.isUndefined(value)) {
      value = options[0].value;
    }

    this.setState({
      value,
    });
  }

  componentDidMount() {
    window.addEventListener('blur', this.handleClickOutside, false);
    document.addEventListener('click', this.handleClickOutside, false);
  }

  componentWillUnmount() {
    window.removeEventListener('blur', this.handleClickOutside, false);
    document.removeEventListener('click', this.handleClickOutside, false);
  }

  @autobind
  handleClickOutside(event) {
    const { target } = event;
    if (target !== window && this.wrapper && this.wrapper.contains(target)) {
      return;
    }

    this.setState({
      open: false,
    });
  }

  @autobind
  handleLabelClick() {
    this.setState({
      open: true,
    });
  }

  @autobind
  handleOptionClick(value) {
    const { onChange } = this.props;
    const didValueChange = value === this.state.value;

    this.setState({
      value,
      open: false,
    });

    if (didValueChange) {
      onChange(value);
    }
  }

  render() {
    const { options, rounded, className, optionClassName, selectedOptionClassName, labelClassName } = this.props;
    const { open, value } = this.state;

    const styleNames = classnames('dropdown', {
      open,
      rounded,
    });

    const { label } = _.find(options, { value });

    return (
      <div styleName={styleNames}
           className={className}
           ref={node => (this.wrapper = node)}>

        <div styleName="label"
             className={labelClassName}
             onClick={this.handleLabelClick}>
          <span styleName="value"
                title={label}>
            {label}
          </span>
          <Icon styleName="triangle-down"
                name="triangle-down" />
        </div>

        <div styleName="options">
          {
            _.map(options, (option, i) => {
              const isSelected = value === option.value;
              const classNames = classnames(optionClassName, {
                [selectedOptionClassName]: isSelected,
              });

              return (
                <Option key={i}
                        value={option.value}
                        selected={isSelected}
                        className={classNames}
                        onClick={this.handleOptionClick}>
                  {option.label}
                </Option>
              );
            })
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/dropdown/dropdown.js